import * as React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Heading, Panel, Separator, Text } from "@nju/ui";

export function ChangeSimEsimOrderPlacedPage() {
  const router = useRouter();
  const params = portalRoutes.mojeKonto.mojaKarta.wymianaKarty.index
    .input(router.query)
    .unwrap();

  return (
    <Panel testId="order-capture-success-panel">
      <Heading
        align="center"
        font="ttfirs"
        tone="neutral"
        variant="h2"
        weight="bold"
      >
        zamówienie złożone
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="document-incircle-succes"
        />
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Text align="center" size={{ "@onlyMobile": "m", "@fromTablet": "xl" }}>
          Postępuj zgodnie ze wskazówkami, by aktywować kartę.
        </Text>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col">
        <Link
          href={portalRoutes.mojeKonto.mojaKarta.index.get({
            ...(params?.userId && { userId: params.userId }),
          })}
          passHref={true}
        >
          <A size={{ "@onlyMobile": "s" }} variant="primary">
            ok
          </A>
        </Link>
      </div>
    </Panel>
  );
}
